import { getGlobalRequestTimeout } from '../config/timeout';
export var REQUEST_TIMEOUT = getGlobalRequestTimeout();
export var B2B_HOMEPAGE_PATH = '/b2b/account/view/homepage/';
export var RETURN_SUMMARY_SESSION_STORAGE_KEY = 'returnSummaryData';
export var SSR_SESSION_STORAGE_KEY = 'orderDetailsData';
export var RETURN_METHOD = {
    IN_STORE: 'In-Store',
    UPS_DROP_OFF: 'UPS',
    LORP: 'LORP',
};
export var ITEM_IMG_SIZE = 48;
export var CALCULATOR_CUTOFF_DATE = new Date('2025-01-18T00:00:00Z');
export var STATE_CODE_TO_NAME_MAP = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    DC: 'Disctrict of Columbia',
    AS: 'American Samoa',
    GU: 'Guam',
    MP: 'Northern Mariana Islands',
    PR: 'Puerto Rico',
    VI: 'US Virgin Islands',
    UM: 'US Minor Outlying Islands',
};
export var US_TERRITORIES = new Set([
    'DC',
    'AS',
    'GU',
    'MP',
    'PR',
    'VI',
    'UM',
]);
